import React from 'react';
import PropTypes from 'prop-types';
import CustomerDuplicateDialog from 'components/modules/customer/merge/CustomerDuplicateDialog';
import { DUPLICATE_DIALOG_MODE } from 'components/modules/customer/merge/duplicateDialogModes';

/**
 * Backward-compatible Suggest Customer entry.
 * - With masterCustomerCode → EDIT mode (Review and Merge → resolve)
 * - Otherwise → SUGGEST mode (create / deals / opp / services)
 */
const SuggestCustomer = ({
    open,
    onClose,
    suggestedCustomer,
    enteredCustomer,
    onUseEntered,
    onUseSuggested,
    isCustomerModule,
    masterCustomerCode,
    onMergeCompleted,
}) => {
    const mode = masterCustomerCode
        ? DUPLICATE_DIALOG_MODE.EDIT
        : DUPLICATE_DIALOG_MODE.SUGGEST;

    return (
        <CustomerDuplicateDialog
            open={open}
            mode={mode}
            onClose={onClose}
            suggestedCustomer={suggestedCustomer}
            enteredCustomer={enteredCustomer}
            onUseEntered={onUseEntered}
            onUseSuggested={onUseSuggested}
            isCustomerModule={isCustomerModule}
            masterCustomerCode={masterCustomerCode}
            onMergeCompleted={onMergeCompleted}
        />
    );
};

SuggestCustomer.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onUseEntered: PropTypes.func.isRequired,
    onUseSuggested: PropTypes.func.isRequired,
    suggestedCustomer: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
    ]).isRequired,
    enteredCustomer: PropTypes.object,
    isCustomerModule: PropTypes.bool,
    masterCustomerCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onMergeCompleted: PropTypes.func,
};

SuggestCustomer.defaultProps = {
    isCustomerModule: false,
    enteredCustomer: {},
    masterCustomerCode: null,
    onMergeCompleted: () => {},
};

export default SuggestCustomer;
